import React, { useRef } from 'react';
import ApiPost from '../../../../../../api-controller-mod/api-serv/post-api/postApi';
import { OurMissionSection, MissionHeaderSection, MediaSaveCallback } from './types';
import { LabelRow, SplitRow, DraftTextField, DraftTextArea } from './primitives';
import ImageUploadField from './imageUploadField';
import { API_ENDPOINTS } from '../../../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider';

interface OurMissionEditorProps {
  data:               OurMissionSection;
  onChange:           (v: OurMissionSection) => void;
  onMediaClick?:      (onSave: MediaSaveCallback) => void;
  userId:             string;
  registerMediaUsage: (uuid: string) => void;
}

const OurMissionEditor: React.FC<OurMissionEditorProps> = ({
  data, onChange, onMediaClick, userId, registerMediaUsage,
}) => {
  const header = data.content[0]?.headerSection;
  const orig   = useRef(header);

  const set = (p: Partial<MissionHeaderSection>) => onChange({
    ...data,
    content: [{ ...data.content[0], headerSection: { ...header, ...p } }],
  });

  if (!header) return null;

  return (
    <>
      <LabelRow label="Main content title" />
      <SplitRow currentText={`[ ${orig.current?.label ?? ''} ]`}>
        <DraftTextField placeholder="[ Vision ]" onChange={v => set({ label: v })} />
      </SplitRow>

      <LabelRow label="Main title" />
      <SplitRow currentText={orig.current?.title ?? ''}>
        <DraftTextField placeholder="Empower you future" onChange={v => set({ title: v })} />
      </SplitRow>

      <LabelRow label="Main description" />
      <SplitRow currentText={orig.current?.description ?? ''} multiline>
        <DraftTextArea placeholder="A company automatically collects..." rows={3}
          onChange={v => set({ description: v })} />
      </SplitRow>

      <ImageUploadField
        label="Upload image"
        currentSrc={header.image || undefined}
        onFile={async f => {
          try {
            const formData = new FormData();
            formData.append('file',        f);
            formData.append('type',        'IMAGE');
            formData.append('filename',    f.name);
            formData.append('alt',         '');
            formData.append('description', '');

            const res           = await ApiPost(`${API_ENDPOINTS.UPLOAD_MEDIA}?userUuid=${userId}`, formData);
            const uploadedUrl:  string | undefined = (res as any)?.data?.data?.url;
            const uploadedUuid: string | undefined = (res as any)?.data?.data?.uuid;

            if (uploadedUrl) {
              set({ image: uploadedUrl });
              if (uploadedUuid) registerMediaUsage(uploadedUuid);
              return uploadedUrl;
            }
          } catch (err) {
            console.error('[MissionImgUpload] upload failed:', err);
          }
          return undefined;
        }}
        onMediaClick={
          onMediaClick
            ? () => onMediaClick(item => { if (item) set({ image: item.src }); })
            : undefined
        }
      />
    </>
  );
};

export default OurMissionEditor;